import { buildInvoiceDraft } from "./accounting-invoice-use-cases.js";
/** UI only exposes AED at launch — mirrors
 * `accounting-scan-use-cases.ts`'s `DEFAULT_STABLE_CURRENCY`. */
const DEFAULT_STABLE_CURRENCY = "AED";
function previousCalendarMonthRange(now) {
    const year = now.getUTCFullYear();
    const month = now.getUTCMonth(); // 0-based; "this month" index.
    const firstOfPreviousMonth = new Date(Date.UTC(year, month - 1, 1));
    const lastOfPreviousMonth = new Date(Date.UTC(year, month, 0));
    const iso = (date) => date.toISOString().slice(0, 10);
    return { start: iso(firstOfPreviousMonth), end: iso(lastOfPreviousMonth) };
}
/**
 * The fixed-monthly auto-generate job (`docs/products/stable.md`: "opts a
 * Stable into a fixed-monthly auto-generate toggle that produces drafts for
 * review instead of auto-approving them"). For every Stable with the
 * toggle on, generates (or refreshes) one `HORSE`-target draft per horse
 * for the previous full calendar month — never approves anything, exactly
 * `buildInvoiceDraft`'s ordinary behavior with `generatedByHorsemanId: null`
 * marking it as system-generated.
 *
 * Deployment shape: real, tested application code; the actual EventBridge
 * Scheduler wiring that would invoke this monthly from a `scheduled-worker`
 * Lambda is out of scope for this phase, mirroring ADR 0011's
 * "disabled-first" posture and ADR 0016's identical note for the
 * Vaccinations daily scan — see the Phase 7 completion report.
 *
 * Because every horse has zero Primary Owner links until Link An Owner
 * ships (`domain/accounting/owner-link.ts`), every horse this scan
 * evaluates today resolves to `NO_PRIMARY_OWNER` and generates nothing —
 * this is the correct, honest behavior for a real but currently-empty data
 * seam, not a bug.
 */
export async function runAccountingAutoInvoiceScan(dependencies) {
    const now = dependencies.clock.now();
    const { start, end } = previousCalendarMonthRange(now);
    const stableIds = await dependencies.repository.listStablesWithAccountingAutoInvoiceEnabled();
    let horsesEvaluated = 0;
    let draftsGenerated = 0;
    for (const stableId of stableIds) {
        const horses = await dependencies.repository.listHorses(stableId);
        for (const horse of horses) {
            horsesEvaluated += 1;
            const result = await buildInvoiceDraft(stableId, { kind: "HORSE", horseId: horse.id }, start, end, DEFAULT_STABLE_CURRENCY, null, dependencies);
            if (result.status === "DRAFT" && result.invoice.lineItems.length > 0) {
                draftsGenerated += 1;
            }
        }
    }
    return {
        stablesScanned: stableIds.length,
        horsesEvaluated,
        draftsGenerated,
    };
}
